import type { ReactNode } from 'react';
import { Component } from 'react';

import { FooterAppSkeleton } from './FooterAppSkeleton';

interface ErrorBoundaryProps {
  children: JSX.Element;
}

interface ErrorBoundaryState {
  error?: Error;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  override readonly state: ErrorBoundaryState = {};

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  override render(): ReactNode {
    const { error }: ErrorBoundaryState = this.state;

    if (error) {
      console.error(error); // eslint-disable-line no-console -- log error

      return <FooterAppSkeleton />;
    }

    const { children }: ErrorBoundaryProps = this.props;

    return children;
  }
}
